import React from 'react';

/**
 * "Someone is typing", as an incoming message at the tail of the stream.
 *
 * This used to render inside the composer band, immediately above the input —
 * which put the OTHER person's activity in the one strip of the screen that
 * belongs to the current user, so it read as "you are typing". On the incoming
 * side of the stream it reads as what it actually is: a message on its way.
 *
 * The label is text, not just dots. Three pulsing dots alone are a convention
 * rather than a statement, they say nothing to a screen reader, and they leave
 * nothing behind when the animation is suppressed for reduced motion.
 *
 * @param name Sender, for a group where knowing WHO is typing is the point.
 *             Omitted in a 1:1, where there is only one person it can be.
 */
const TypingIndicator = ({ name }) => (
  <div className="typing-row">
    <div className="typing-bubble" role="status" aria-live="polite">
      <span className="typing-dots" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
      <span className="typing-label">{name ? `${name} is typing…` : 'typing…'}</span>
    </div>
  </div>
);

export default TypingIndicator;
